const screens = {
    sm: '768px',
    md: '1024px',
    lg: '1366px'
};
const screensWidth = {
    sm: 768,
    md: 1024,
    lg: 1366
};
function matchMediaQuery(options) {
    let mediaQuery = '';
    if ('string' == typeof options) mediaQuery = `(min-width: ${screens[options] || options})`;
    else {
        const { from, until, only } = options;
        let minWidth = from && 'xs' !== from ? screensWidth[from] : void 0;
        let maxWidth = until ? screensWidth[until] - 1 : void 0;
        if (only) {
            minWidth = 'xs' !== only ? screensWidth[only] : void 0;
            switch(only){
                case 'xs':
                    maxWidth = screensWidth.sm - 1;
                    break;
                case 'sm':
                    maxWidth = screensWidth.md - 1;
                    break;
                case 'md':
                    maxWidth = screensWidth.lg - 1;
                    break;
                default:
                    maxWidth = void 0;
            }
        }
        if (minWidth && maxWidth) mediaQuery = `(min-width: ${minWidth}px) and (max-width: ${maxWidth}px)`;
        else if (minWidth) mediaQuery = `(min-width: ${minWidth}px)`;
        else if (maxWidth) mediaQuery = `(max-width: ${maxWidth}px)`;
    }
    const nativeMediaQueryList = window.matchMedia(mediaQuery);
    return nativeMediaQueryList;
}
const src_matchMediaQuery = matchMediaQuery;
export default src_matchMediaQuery;
export { screens, screensWidth };
